/**
 * Populates any [data-fbc-badge] element (rendered by the
 * 'feedback-company-badge' snippet) with GolftasPro's live Feedback Company
 * store score, star rating and review count. Reuses the same widget UUID
 * and loader mechanism as the existing footer rating, so it always shows
 * the same live numbers and can safely run alongside it (and alongside
 * multiple copies of itself) on the same page. The logomark in the badge is
 * static, theme-colored markup (see the snippet) - only the score, stars and
 * review count are pulled live from Feedback Company's own widget data.
 */
(function () {
  var UUID = 'cde30567-74bf-46a5-93d3-6ccec40f79b2';
  var STAR_POINTS = '39.2300134 48 33.4778997 29.6870393 48 18.2634146 29.8577486 18.2634146 24 0 18.1422514 18.2634146 2.08166817e-17 18.2634146 14.5221003 29.6870393 8.76998657 48 24 36.9038077';

  function ensureWidgetLoaded() {
    if (document.getElementById('__fbcw__' + UUID)) return;
    var source = document.createElement('div');
    source.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;visibility:hidden;';
    document.body.appendChild(source);
    var embed = document.createElement('script');
    embed.type = 'text/javascript';
    embed.id = '__fbcw__' + UUID;
    embed.text =
      '"use strict";!function(){window.FeedbackCompanyWidgets=window.FeedbackCompanyWidgets||{queue:[],loaders:[]};' +
      'var options={uuid:"' + UUID + '",version:"1.2.1",prefix:""};' +
      'if(void 0===window.FeedbackCompanyWidget){' +
      'if(window.FeedbackCompanyWidgets.queue.push(options),!document.getElementById("__fbcw_FeedbackCompanyWidget")){' +
      'var scriptTag=document.createElement("script");' +
      'scriptTag.onload=function(){if(window.FeedbackCompanyWidget)for(;0<window.FeedbackCompanyWidgets.queue.length;)' +
      'options=window.FeedbackCompanyWidgets.queue.pop(),window.FeedbackCompanyWidgets.loaders.push(new window.FeedbackCompanyWidgetLoader(options))},' +
      'scriptTag.id="__fbcw_FeedbackCompanyWidget",' +
      'scriptTag.src="https://www.feedbackcompany.com/includes/widgets/feedback-company-widget.min.js",' +
      'document.body.appendChild(scriptTag)}' +
      '}else window.FeedbackCompanyWidgets.loaders.push(new window.FeedbackCompanyWidgetLoader(options))}();';
    source.appendChild(embed);
  }

  function initInstance(root) {
    root.setAttribute('data-fbc-init', '1');

    var scoreEl = root.querySelector('[data-fbc-badge-score]');
    var starsEl = root.querySelector('[data-fbc-badge-stars]');
    var countEl = root.querySelector('[data-fbc-badge-count]');
    var done = false;
    var observer;

    function render() {
      if (done) return;
      var score = document.querySelector('.__fbcw__bar-widget__score');
      var stars = document.querySelectorAll('.__fbcw__bar-widget__stars .__fbcw__star');
      if (!score || stars.length === 0) return;

      var text = (score.textContent || '').trim();
      var n = parseFloat(text.replace(',', '.'));
      if (isNaN(n)) {
        var m = text.match(/^[0-9]+([.,][0-9]+)?/);
        n = m ? parseFloat(m[0].replace(',', '.')) : NaN;
      }
      if (isNaN(n)) return;

      var barWidget = score.closest('.__fbcw__bar-widget');

      done = true;
      scoreEl.textContent = n.toFixed(1).replace('.', ',');

      var starsHtml = '';
      for (var i = 0; i < 5; i++) {
        var poly = stars[i] && stars[i].querySelector('polygon');
        var empty = !poly || poly.hasAttribute('fill-opacity');
        starsHtml += '<svg class="fbc-badge__star' + (empty ? ' is-empty' : '') + '" viewBox="0 0 48 48" aria-hidden="true"><polygon points="' + STAR_POINTS + '"/></svg>';
      }
      starsEl.innerHTML = starsHtml;

      var reviewsEl = barWidget && barWidget.querySelector('.__fbcw__bar-widget__amount-of-reviews');
      if (reviewsEl && countEl) {
        countEl.textContent = reviewsEl.textContent.replace(/\s+/g, ' ').trim();
      }

      root.classList.add('is-ready');
      if (observer) observer.disconnect();
    }

    observer = new MutationObserver(render);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    render();
    setTimeout(function () {
      if (observer) observer.disconnect();
    }, 15000);
  }

  function init() {
    var roots = document.querySelectorAll('[data-fbc-badge]:not([data-fbc-init])');
    if (!roots.length) return;
    ensureWidgetLoaded();
    for (var i = 0; i < roots.length; i++) initInstance(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  }
  else {
    init();
  }
})();
